import type { IntlState } from './types';

export interface IntlStore {
  intl: IntlState;
}

export const selectLocale = (store: IntlStore): string => store.intl.locale;
